import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";

const LOGO_URL = "https://storage.googleapis.com/uxpilot-auth.appspot.com/locals-assets/locals-logo.png";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-primary flex flex-col">
      {/* Header */}
      <header className="bg-brand-primary px-6 py-4">
        <Link to="/" className="flex items-center gap-2 w-fit">
          <div className="bg-white rounded-lg p-1">
            <img src={LOGO_URL} alt="LocaLS Logo" className="h-8 w-auto object-contain" />
          </div>
        </Link>
      </header>

      {/* Main */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        {/* Big number */}
        <div className="relative mb-6 select-none">
          <span
            className="font-heading font-bold text-[120px] sm:text-[180px] leading-none text-brand-primary/10"
            aria-hidden="true"
          >
            404
          </span>
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="font-heading font-bold text-5xl sm:text-7xl text-brand-primary">
              404
            </span>
          </div>
        </div>

        <h1
          className="font-heading font-bold text-2xl sm:text-3xl text-text-primary mb-3"
          data-testid="not-found-heading"
        >
          Oops! Page not found.
        </h1>
        <p className="font-body text-text-secondary max-w-sm mb-10">
          The page you're looking for doesn't exist or may have been moved. Let's get you back home.
        </p>

        <div className="flex flex-col sm:flex-row gap-3">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 bg-brand-primary hover:bg-brand-primary/90 text-white font-body font-semibold rounded-full px-8 py-3 transition-colors"
            data-testid="not-found-home-btn"
          >
            <Home size={16} />
            Go to Homepage
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 bg-transparent border border-brand-primary text-brand-primary font-body font-semibold rounded-full px-8 py-3 hover:bg-brand-primary/5 transition-colors"
            data-testid="not-found-back-btn"
          >
            <ArrowLeft size={16} />
            Go Back
          </button>
        </div>
      </main>

      {/* Footer strip */}
      <footer className="bg-brand-primary text-white text-center py-5 px-6">
        <p className="font-body text-sm text-white/80">
          © 2026 LocaLS. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
